import { addLastPrefixES } from '../transforms/addLastPrefix';
import { capitalizeFirstLetter } from '../transforms/capitalizeFirstLetter';
import { removeDots } from '../transforms/removeDots';
import { uppercase } from '../transforms/uppercase';
import { overrideBaseLocale } from './base-config';
export var esES = overrideBaseLocale('es-ES', {
    dayOfWeekShort: {
        options: {
            weekday: 'short',
        },
        transforms: [removeDots],
    },
    dayOfWeekShortUppercase: {
        options: {
            weekday: 'short',
        },
        transforms: [removeDots, uppercase],
    },
    dayOfWeekLongPropercase: {
        options: {
            weekday: 'long',
        },
        transforms: [capitalizeFirstLetter],
    },
    dayOfWeekShortPropercase: {
        options: {
            weekday: 'short',
        },
        transforms: [removeDots, capitalizeFirstLetter],
    },
    lastDayOfWeekLong: {
        options: {
            weekday: 'long',
        },
        transforms: [addLastPrefixES],
    },
    monthShort: {
        options: {
            month: 'short',
        },
        transforms: [removeDots],
    },
    monthShortUppercase: {
        options: {
            month: 'short',
        },
        transforms: [removeDots, uppercase],
    },
    monthLongPropercase: {
        options: {
            month: 'long',
        },
        transforms: [capitalizeFirstLetter],
    },
    monthShortPropercase: {
        options: {
            month: 'short',
        },
        transforms: [capitalizeFirstLetter, removeDots],
    },
});
//# sourceMappingURL=es-ES.js.map